import React from 'react';
import { translateActivity, translateMicroservice } from '../../../utils/logTranslations';
import './ActivityFeed.css';

const fmt = (ts) => {
  if (!ts) return '—';
  const d = new Date(ts);
  if (isNaN(d)) return '—';
  return d.toLocaleString('fr-FR', {
    day: '2-digit', month: '2-digit', year: 'numeric',
    hour: '2-digit', minute: '2-digit', second: '2-digit',
  });
};

const ActivityFeed = ({ stats, recent }) => {
  const top = stats?.most_used_services || [];
  const max = top[0]?.count || 1;

  return (
    <div className="af-wrapper">
      {top.length > 0 && (
        <div className="af-section">
          <h4 className="af-title">Services les plus utilisés</h4>
          <ul className="af-services">
            {top.map((s, i) => {
              // s.service peut être "Weather_service" (ms seul) ou "auth.login.dashboard" (ms.endpoint)
              const hasDot = s.service?.includes('.');
              const { label, msLabel } = translateActivity({ service: s.service });

              // Si pas de point → c'est un nom de ms seul → on traduit directement
              const displayLabel  = hasDot ? label : translateMicroservice(s.service);
              const displayMsLabel = hasDot ? msLabel : null;

              return (
                <li key={i} className="af-svc">
                  <span className="af-svc-name">
                    {displayLabel}
                    {displayMsLabel && displayMsLabel !== '—' && (
                      <span className="af-svc-ms">({displayMsLabel})</span>
                    )}
                  </span>
                  <div className="af-track">
                    <div className="af-fill" style={{ width: `${(s.count / max) * 100}%` }} />
                  </div>
                  <span className="af-svc-count">{s.count}</span>
                </li>
              );
            })}
          </ul>
        </div>
      )}

      <div className="af-section">
        <h4 className="af-title">Activité récente</h4>
        <ul className="af-timeline">
          {recent.slice(0, 20).map((a, i) => {
const { label } = translateActivity({ service: a.service });

const displayLabel = label
  ? label.charAt(0).toLowerCase() + label.slice(1)
  : '—';            return (
              <li key={i} className="af-tl">
                <div className="af-dot" />
                <div className="af-tl-body">
                  <span className="af-tl-svc">{displayLabel}</span>
                  <span className="af-tl-time">{fmt(a.timestamp)}</span>
                </div>
              </li>
            );
          })}
          {!recent.length && <li className="af-empty">Aucune activité récente</li>}
        </ul>
      </div>
    </div>
  );
};

export default ActivityFeed;